import * as React from 'react';
import { observer } from 'mobx-react';
import { PaymentMethod } from '../../../../commonv3/types/payments';

type PaymentMethodViewProps = {
    paymentMethod: PaymentMethod;
};

export const PaymentMethodView = observer(({ paymentMethod }: PaymentMethodViewProps) => {
    switch (paymentMethod) {
        case 'credit_card':
            return <span>クレジットカードでの支払い</span>;
        case 'transfer':
            return <span>銀行口座での振込み</span>;
        default:
            return <span>不明なお支払方法</span>;
    }
});
